export const ssnLength = 9;